<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import TaxProfileForm from "./components/TaxProfileForm.vue"

defineProps<{
  tax_profile: {
    id?: number | null
    company_id: number | ""
    name: string
    active: boolean
    default: boolean
    credit_icms: boolean
    credit_pis_cofins: boolean
    ipi_included_in_cost: boolean
    estimated_sales_tax_percent: string
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <TaxProfileForm
      mode="create"
      title="Criar Perfil Fiscal"
      subtitle="Configure um novo perfil fiscal para uma empresa com parametros de creditos e impostos."
      :tax_profile="tax_profile"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>
